"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.profession.select.label': '选择您的职业以开始入职：',
    'onboarding.profession.select.placeholder': '-- 选择职业 --',
    'onboarding.profession.empty': '没有可用的职业。',
};
